import { QualityRepository } from '../../domain/repositories/quality.repository';
import { QualityEntity } from '../../domain/entities/quality.entity';

export class ToggleQualityStatusUseCase {
  constructor(private readonly qualityRepository: QualityRepository) {}

  async execute(id: string, isActive: boolean): Promise<QualityEntity> {
    return this.qualityRepository.toggleQualityStatus(id, isActive);
  }
}
